export default __webpack_public_path__ + "static/media/obchodne.a72c855d.jpg";